<template>
  <div id="multiselectacces" class="mt2">
    <div class="dropdown dropdown-filter" @click="showDropdown">
      <div class="overselect"></div>
      <div class="c-form-input">
        <h2 class="raleway-semi-p13">Accessibilité</h2>
        <img src="../../images/Fleche haut.svg" v-set-alt v-if="show">
        <img src="../../images/flechebas-simple.svg" v-set-alt v-else >
      </div>
    </div>
    <div class="multiselect" v-if="show">
      <ul>
        <div class="row row-selectoptions mt-3">
          <div class="col-10">
            <li v-for="(option, index) in options" :key="index">
              <input type="checkbox" :id="index" :value="option.value" v-model="selected">
              <label class="raleway-reg-p13 ml-2 " :for="index">Accessibilité aux PMR </label>
            </li>
            <li v-for="(option, index) in options" :key="index">
              <input type="checkbox" :id="index" :value="option.value" v-model="selected">
              <label class="raleway-reg-p13 ml-2" :for="index">Adult only</label>
            </li>
            <li v-for="(option, index) in options" :key="index">
              <input type="checkbox" :id="index" :value="option.value" v-model="selected">
              <label class="raleway-reg-p13 ml-2" :for="index">Aucune restriction d'âge</label>
            </li>
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>


  export default{
   name: 'multiselectacces',
   props: ['options'],
    data() {
      return {
        show: false,
        selected: []
      }
    },
    methods: {
      showDropdown() {
        this.show = !this.show
      }
    },
    // watch: {
    //   selected(val) {
    //     this.$emit('checked', val)
    //   }
    // }
  }
</script>

<style lang="scss" scope='app/assets/stylesheets/components/lodging-filter'>


</style>
